/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 
import React, { useContext } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import {InputLabel} from '@material-ui/core';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import elementValidate from '../Component/validation';
import ThemeControls from "../Component/AllThemesControl";

import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import dayjs from 'dayjs';
import moment from 'moment';



export default function DateTime(props) {
  const {useStyle} = ThemeControls;
  const classes = useStyle();
  const { field_type, field_id, field_label, field_pastDisable,field_placeholder,field_disabled, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
  const { handleChange } = useContext(FormContext)

  
  const [value, setValue] = React.useState(field_value);
  //console.log(field_value)

  const field = {
    field_id:field_id,
    field_type:field_type,
    field_value:field_value,
    field_helperText:field_helperText,
    field_minlength:field_minlength,
    field_maxlength:field_maxlength,
    field_minvalue:field_minvalue,
    field_maxvalue:field_maxvalue,
    field_value_type:field_value_type,
    field_mandatory:field_mandatory,
    field_label:field_label,
    field_error_msg_minvalue:field_error_msg_minvalue
  }
    function handleBlur(){
      elementValidate(field)
      // setError(field['field_helperText'])
    }
   
    function formatDateToMMDDYYYY(inputDate) {
      if(inputDate){
        const [datePart, timePart] = inputDate.split(' ');
  
        const [day, month, year] = datePart.split('-');
    
        const swappedDateString = `${month}-${day}-${year} ${timePart}`;
      
        return swappedDateString;
      }else{
        return null;
      }
   
    }

    function convertToTimestamp(inputDate) {
      // Split the input string into date and time parts
      const [datePart, timePart] = inputDate.split(' ');
    
      // Split the date part into day, month, and year
      const [day, month, year] = datePart.split('-');
    
      // Split the time part into hours and minutes
      const [hours, minutes, seconds] = timePart.split(':');
    
      // Create a new Date object with the components
      const dateObject = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
    
      // Get the timestamp string in UTC format
      const timestampString = dateObject.toISOString();
    
      return timestampString;
    }
  

  const handleChangeDate = (date) => {
    //console.log(date)
    setValue(date);
    let getDate=moment(new Date(date)).format('DD-MM-YYYY HH:mm:ss');
    //console.log(getDate)
    handleChange(field_id,{},getDate) 
  };

 
  return (
    <div className={classes.inputroot}>    
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDateTimePicker className={classes.input}
        // inputFormat="DD-MM-YYYY HH:mm:ss"
        // defaultValue={value}
        value={value}
        onChange={(date) => {
          handleChangeDate(date)
        }}
         />
    </LocalizationProvider>
    </div>
  );
}
